<p>action-dialog-component works!</p>
